import React from 'react'
import { connect } from 'react-redux'
import { MultiSelect } from '@blueprintjs/select'
import { Button, Dialog, Icon, MenuItem, Spinner } from '@blueprintjs/core'

import { addNewDevice } from 'src/store/modules/runbooks/actions'
import {
    toggleControl,
    singleEditAction,
} from 'src/store/modules/ui/runbook/controls'
import { getDeviceResults, searchDevices } from 'src/store/modules/cmdb/devices'
import CustomerSelect from 'src/components/CustomerSelect'
import { clearSelectedCustomer } from 'src/store/modules/cmdb/solutions'
import {
    clearSearchCustomers,
    getCustomerById,
} from 'src/store/modules/cmdb/customers'
import * as solutionModules from 'src/store/modules/cmdb/solutions'

const mapStateToProps = (state) => ({
    runbookId: state.ui.runbook.activeRunbook,
    openAction: state.ui.runbook.controls.singleOpenAction,
    isAdding: state.ui.runbook.controls.isAddingDevices,
    devicesLoading: state.cmdb.devices.loading,
    devices: getDeviceResults(state),
    selectedCustomer: getCustomerById(
        state,
        state.cmdb.solutions.selectedCustomer
    ),
})

class AddDevicesDialog extends React.Component {
    state = {
        deviceList: [],
    }
    deviceInput = React.createRef()
    deviceInputRef = (ref) => (this.deviceInput = ref)
    handleClose = () => {
        this.setState({ deviceList: [] })
        this.props.singleEditAction(null)
        this.props.toggleControl('isAddingDevices')
        this.props.clearSelectedCustomer()
        this.props.clearSearchCustomers()
    }
    deviceRenderer = (item, { handleClick, modifiers }) => {
        return (
            <MenuItem
                active={modifiers.active}
                key={item.id}
                onClick={handleClick}
                text={item.name || item.id}
            />
        )
    }
    deviceTagRenderer = (item) => item.id
    handleDeviceRemove = (item) =>
        this.setState({
            deviceList: this.state.deviceList.filter((i) => i.id !== item),
        })
    handleDevicesAdd = () => {
        this.state.deviceList.forEach((device) => {
            this.props.addNewDevice(this.props.runbookId, device, {
                fromAction: this.props.openAction,
                parent: true,
            })
        })
        this.handleClose()
    }

    handleCustomerSelect = (customer) => {
        this.props.onCustomerSelect(customer.id)
    }

    render() {
        const {
            openAction,
            isAdding,
            devices,
            devicesLoading,
            selectedCustomer,
            searchDevices,
        } = this.props
        if (!openAction) return null
        return (
            <Dialog
                canOutsideClickClose={false}
                icon="changes"
                isOpen={isAdding}
                onClose={this.handleClose}
                title="Add Devices"
            >
                <div className="bp3-dialog-body">
                    <div style={{ marginBottom: 5 }}>
                        <CustomerSelect
                            selected={selectedCustomer}
                            onCustomerSelect={this.handleCustomerSelect}
                        />
                    </div>
                    <MultiSelect
                        items={devices}
                        itemRenderer={this.deviceRenderer}
                        onItemSelect={(i) => {
                            this.setState({
                                deviceList: [...this.state.deviceList, i],
                            })
                        }}
                        placeholder={'Search for a device'}
                        resetOnSelect={true}
                        selectedItems={this.state.deviceList}
                        //noResults={<MenuItem disabled={true} text="No results." />}
                        tagRenderer={this.deviceTagRenderer}
                        tagInputProps={{
                            inputRef: this.deviceInputRef,
                            disabled: !selectedCustomer,
                            onRemove: this.handleDeviceRemove,
                            rightElement: devicesLoading ? (
                                <Spinner size={Icon.SIZE_STANDARD} />
                            ) : null,
                        }}
                        onQueryChange={(value) =>
                            searchDevices(value, selectedCustomer.id)
                        }
                        popoverProps={{
                            className: 'multiselect_wrapper',
                            minimal: true,
                        }}
                    />
                </div>
                <div className="bp3-dialog-footer">
                    <div className="bp3-dialog-footer-actions">
                        <Button
                            intent="primary"
                            large
                            onClick={this.handleDevicesAdd}
                            text="Add"
                        />
                        <Button
                            large
                            intent="lynch-underline"
                            text="Cancel"
                            onClick={this.handleClose}
                        />
                    </div>
                </div>
            </Dialog>
        )
    }
}

export default connect(mapStateToProps, {
    toggleControl,
    singleEditAction,
    searchDevices,
    addNewDevice,
    clearSelectedCustomer,
    clearSearchCustomers,
    onCustomerSelect: (customerId) =>
        solutionModules.selectCmdbSolutionCustomer(customerId),
})(AddDevicesDialog)
